import { useEffect, useState } from "react";
import moment from "moment";
import { ApiRoutes } from "../core/dictionary/api-url";
import { individualOrganisationActionType } from "../core/dictionary/global-enums";
import Loader from "./designs/loader";
import axiosService from "../core/services/axios-service";

export default function ViewCoachTeamMember({ id, type }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!id) return;
    setLoading(true);
    axiosService
      .get(`${ApiRoutes.VIEW_COACH_TEAM_MEMBER}/${id}`)
      .then((res) => {
        if (res.data && res.data.success && res.data.data) {
          setData(res.data.data);
        } else {
          setError(`${type === individualOrganisationActionType.viewCoach ? "Coach" : "Team Member"} not found.`);
        }
      })
      .catch(() => setError("Server error. Please try again."))
      .finally(() => setLoading(false));
  }, [id, type]);

  if (loading) return <Loader text={`Loading ${type === individualOrganisationActionType.viewCoach ? "Coach" : "Team Member"} details...`} />;
  if (error) return <div className="text-danger p-3">{error}</div>;
  if (!data) return null;

  return (
    <div className="card p-4">
      <h4 className="mb-3">{data.fullName}</h4>
      <div className="mb-2">
        <strong>Title:</strong> {data.title}
      </div>
      <div className="mb-2">
        <strong>Contact Number:</strong> {data.phoneNumber}
      </div>
      <div className="mb-2">
        <strong>Email:</strong> {data.email}
      </div>
      <div className="mb-2">
        <strong>Type:</strong> {data.role === "coach" ? "Coach" : "Team Member"}
      </div>
      <div className="mb-2">
        <strong>License Number:</strong> {data.licenseNumber}
      </div>
      
      <div className="mb-2">
        <strong>Department:</strong> {data.department}
      </div>
      <div className="mb-2">
        <strong>Created At:</strong>{" "}
        {moment(data.createdAt).format("Do MMM YYYY, h:mm A")}
      </div>
      <div className="mb-2">
        <strong>Last Updated At:</strong>{" "}
        {moment(data.updatedAt).format("Do MMM YYYY, h:mm A")}
      </div>
    </div>
  );
}